import { START_DISCARD_TIME, PAUSE_DISCARD_TIME, DECREASE_DISCARD_TIME, RESET_DISCARD_TIME } from "../actions/actionCardDiscardTime";
const { CartDiscardTime } = window['runConfig'];
const initialState = {
    DiscardTime: 60 * CartDiscardTime,
    timerid: 0
};

function reducerCardDiscardTime(state = initialState, action) {
    switch (action.type) {
        case START_DISCARD_TIME: {
            return {
                ...state,
                DiscardTime: state.DiscardTime - 1,
                timerid: action.payload.timerid
            };
        }
        case PAUSE_DISCARD_TIME: {
            clearInterval(state.timerid)
            return {
                ...state,
                timerid: 0
            };
        }
        case DECREASE_DISCARD_TIME: {
            return {
                ...state,
                DiscardTime: state.DiscardTime - 1
            };
        }
        case RESET_DISCARD_TIME: {
            clearInterval(state.timerid)
            return {
                ...state,
                DiscardTime: 60 * CartDiscardTime,
                timerid: 0
            };
        }
        default: {
            return state;
        }
    }
}

export default reducerCardDiscardTime;
